import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export interface PaymentOverdueModalData {
  daysOverdue: number;
  contactEmail: string | null;
}

/** Seconds the notice stays locked, applied on every appearance. */
const SECONDS_LOCKED = 60;

@Component({
  selector: 'app-payment-overdue-modal',
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './payment-overdue-modal.component.html',
  styleUrl: './payment-overdue-modal.component.scss',
})
export class PaymentOverdueModalComponent implements OnInit, OnDestroy {
  secondsLeft = SECONDS_LOCKED;
  private timerId: any;

  constructor(
    public dialogRef: MatDialogRef<PaymentOverdueModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PaymentOverdueModalData,
  ) {}

  get canClose(): boolean {
    return this.secondsLeft <= 0;
  }

  get contactEmail(): string | null {
    return this.data.contactEmail;
  }

  get daysText(): string {
    const days = this.data.daysOverdue;
    return `${days} día${days === 1 ? '' : 's'}`;
  }

  ngOnInit(): void {
    this.timerId = setInterval(() => {
      this.secondsLeft--;
      if (this.canClose) clearInterval(this.timerId);
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.timerId) clearInterval(this.timerId);
  }

  close(): void {
    if (this.canClose) this.dialogRef.close();
  }
}
